/** Wochentage in der Schreibweise des Backends (`java.time.DayOfWeek`), Reihenfolge Mo–So. */
export const WEEKDAYS = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'] as const;

export type Weekday = (typeof WEEKDAYS)[number];

export const WORKDAYS: readonly Weekday[] = WEEKDAYS.slice(0, 5);

export type ScheduleOutcome = 'STARTED' | 'SKIPPED_BUSY' | 'FAILED' | 'MISSED' | 'PAUSED';

export type SchedulePausedReason = 'RUNNER_REMOVED' | 'NO_PERMISSION';

/** Zeitplan eines Rechner-Laufs (NEX-1758). Genau eines von `runnerId` und `requiredLabels` ist gesetzt. */
export interface TestRunSchedule {
  weekdays: Weekday[];
  /** `HH:mm` in `zone`. */
  time: string;
  /** IANA-Zone, z. B. `Europe/Berlin`. */
  zone: string;
  runnerId: string | null;
  requiredLabels: string[];
  enabled: boolean;
  /** ISO-Zeitpunkt; `null`, solange der Zeitplan pausiert ist. */
  nextRunAt: string | null;
  lastRunAt: string | null;
  lastOutcome: ScheduleOutcome | null;
  lastMessage: string | null;
  lastExecutionId: string | null;
  pausedReason: SchedulePausedReason | null;
  createdByName: string | null;
  updatedByName: string | null;
}

export interface UpsertTestRunScheduleRequest {
  weekdays: Weekday[];
  time: string;
  zone: string;
  runnerId: string | null;
  requiredLabels: string[];
  enabled: boolean;
}
